import React from 'react'
import { useIntl } from 'react-intl'
import { Typography } from '@material-ui/core'

const Restricted = () => {
  const { formatMessage } = useIntl()

  return (
    <Typography className="italic text-grey-200 text-14">
      {formatMessage({
        id: 'restricted.label',
      })}
    </Typography>
  )
}

export default Restricted
